import { formatDate, API_DATE_FORMAT } from '../../../constants/helpers/dates';

import MessageAdapter from './messageAdapter';
import { Severity, Log } from './interfaces';

class NortadaLogger {
  private static _instance: NortadaLogger;

  private logs: Log[] = [];

  private static showMessage: MessageAdapter;

  public static getInstance() {
    if (!NortadaLogger._instance) {
      NortadaLogger._instance = new NortadaLogger();
    }
    return NortadaLogger._instance;
  }

  private saveLog(message: string, severity: Severity) {
    this.logs.push({
      time: formatDate(new Date(), API_DATE_FORMAT),
      severity,
      message
    });
  }

  critical<T = never>(message: string): T {
    this.saveLog(message, 'critical');
    NortadaLogger.showMessage.critical(message);

    return (undefined as unknown) as T;
  }

  error(message: string) {
    this.saveLog(message, 'error');
    NortadaLogger.showMessage.error(message);
  }

  warn(message: string) {
    this.saveLog(message, 'warn');
    NortadaLogger.showMessage.warn(message);
  }

  info(message: string) {
    this.saveLog(message, 'info');
    NortadaLogger.showMessage.info(message);
  }

  showLogs(): Log[] {
    NortadaLogger.showMessage.showLogs(this.logs);

    return this.logs;
  }

  clearLogs() {
    this.logs = [];
  }

  settings(showMessage: MessageAdapter) {
    NortadaLogger.showMessage = showMessage;
  }
}

export const nortadaLogger = NortadaLogger.getInstance();
